import React from 'react';
import { useTranslation } from 'react-i18next';

import { UseMutationResult } from '@tanstack/react-query';
import { CustomConfirmationModal } from '../../../../../UiComponentsLibrary/CustomConfirmationModal';
import { ApiError } from '../../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../../Shared/interfaces/ApiResponse';
import { ErrorDisplay } from '../../../../../Shared/components/ErrorDisplay/ErrorDisplay';
import { QueueSheetManagementRows } from '../../interface/QueueSheetInterface';
import { LeftAlignedErrorContainer } from '../../../../../UserManagement/components/UserManagement/UserManagement.styles';

interface BookingCancelModalProps {
  isCancelModalOpen: boolean;
  bookingToCancel: QueueSheetManagementRows | null;
  handleConfirmCancelBooking: () => void;
  handleCloseCancelModal: () => void;
  cancelBookingMutation: UseMutationResult<
    ApiResponseKeys,
    ApiError,
    string,
    unknown
  >;
}

export const BookingCancelModal: React.FC<BookingCancelModalProps> = ({
  isCancelModalOpen,
  bookingToCancel,
  handleConfirmCancelBooking,
  handleCloseCancelModal,
  cancelBookingMutation,
}) => {
  const { t } = useTranslation();

  return (
    <CustomConfirmationModal
      isOpen={isCancelModalOpen}
      title={t('cancel-booking-modal-title')}
      message={t('cancel-booking-modal-message', {
        entryId: bookingToCancel?.entryId,
      })}
      onConfirmCb={handleConfirmCancelBooking}
      onCancelCb={handleCloseCancelModal}
      confirmButtonText={t('cancel-booking-modal-confirmation-button-label')}
      confirmButtonDisabled={cancelBookingMutation.isPending}
    >
      {cancelBookingMutation.isError && (
        <LeftAlignedErrorContainer>
          <ErrorDisplay error={cancelBookingMutation.error} />
        </LeftAlignedErrorContainer>
      )}
    </CustomConfirmationModal>
  );
};
